<template>
  <span>
    <a :href="protocol + value" target="_blank" class="tdn">
      <v-icon color="primary" class="mr-2" large>{{ icon }}</v-icon>
      <span class="grey--text text--darken-2">{{ label }}</span>
      {{ value }}
      <span class="grey--text"
        ><small>{{ remark }}</small></span
      >
    </a>
    <br /><br />
  </span>
</template>

<script>
export default {
  name: "ContactInLineDisplay",
  props: {
    icon: {
      type: String,
      default: "mdi-circle",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
    protocol: {
      type: String,
      default: "",
    }
  },
};
</script>